import * as tslib_1 from "tslib";
import BrandSubscriptionView from './BrandSubscriptionView';
import groupSubscriptions from '../utils/groupSubscriptions';
import { observer } from 'mobx-react';
import * as React from 'react';
var styles = require('./BrandSubscriptionListView.scss');
var BrandSubscriptionListView = /** @class */ (function (_super) {
    tslib_1.__extends(BrandSubscriptionListView, _super);
    function BrandSubscriptionListView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.renderBrandsSubscriptionsViews = function () {
            var groupedSubscriptions = groupSubscriptions(_this.props.brandsSubscriptions);
            var views = groupedSubscriptions.orderedIds.map(function (id) {
                if (id in groupedSubscriptions.brandSubscriptions) {
                    return (React.createElement(BrandSubscriptionView, { brandSubscriptions: groupedSubscriptions.brandSubscriptions[id], isUnsubscribed: _this.props.isUnsubscribed, key: id }));
                }
                else {
                    return (React.createElement(BrandSubscriptionView, { brandSubscriptions: groupedSubscriptions.subscriptions[id], isUnsubscribed: _this.props.isUnsubscribed, key: id }));
                }
            });
            return views;
        };
        return _this;
    }
    BrandSubscriptionListView.prototype.render = function () {
        if (this.props.brandsSubscriptions[0]) {
            return React.createElement("div", { className: styles.listView }, this.renderBrandsSubscriptionsViews());
        }
        return null;
    };
    BrandSubscriptionListView = tslib_1.__decorate([
        observer
    ], BrandSubscriptionListView);
    return BrandSubscriptionListView;
}(React.Component));
export default BrandSubscriptionListView;
//# sourceMappingURL=BrandSubscriptionListView.js.map